import React from 'react';
import { LaptopIcon, PrinterIcon, SmartphoneIcon, TabletIcon } from 'lucide-react';
import { steps } from '../data/copy';
const devices = [{
  icon: LaptopIcon,
  label: 'Laptop'
}, {
  icon: SmartphoneIcon,
  label: 'Phone'
}, {
  icon: TabletIcon,
  label: 'Tablet'
}, {
  icon: PrinterIcon,
  label: 'Print pages'
}];
export function HowItWorksSection() {
  return <section className="w-full bg-sage-deep py-14 sm:py-16" aria-labelledby="how-heading" data-id="element-110" data-mp="pl4vhfq7xlpo">
      <div className="mx-auto max-w-5xl px-6" data-id="element-111" data-mp="1valr7174d9n">
        <div className="mx-auto max-w-2xl text-center" data-id="element-112" data-mp="3t0ao3hrmawgq">
          <p className="eyebrow text-gold-soft" data-id="element-113" data-mp="3t1u4d8d9x7ii">How it works</p>
          <h2 id="how-heading" className="mt-5 font-display text-[2rem] leading-[1.12] text-ivory sm:text-4xl" data-id="element-114" data-mp="avfqtaix2zkn">
            From purchase to your next class in four steps
          </h2>
        </div>

        <ol className="mt-11 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-115" data-mp="1m7gioyb2v44m">
          {steps.map(step => <li key={step.code} className="flex flex-col" data-id="element-116" data-mp="1i6oam8dxz59x">
              <span className="font-display text-4xl leading-none text-gold" data-id="element-117" data-mp="wawjt6e0drq6">
                {step.code}
              </span>
              <span className="mt-4 h-px w-full bg-ivory/15" aria-hidden="true" data-id="element-118" data-mp="118ocw3qe3jvy" />
              <h3 className="mt-4 font-display text-lg tracking-[0.12em] text-ivory" data-id="element-119" data-mp="15at651cxeei2">
                {step.title.toUpperCase()}
              </h3>
              <p className="mt-2 font-sans text-sm leading-relaxed text-ivory/70" data-id="element-120" data-mp="1a9mhoo8njvfl">
                {step.description}
              </p>
            </li>)}
        </ol>

        <div className="mt-12 flex flex-col items-center gap-5 border-t border-ivory/15 pt-9" data-id="element-121" data-mp="hms0c074tc6c">
          <p className="text-center font-sans text-sm leading-relaxed text-ivory/70" data-id="element-122" data-mp="mkl8gyrzwg99">
            100% digital, delivered as ready-to-use PDFs. No software, no
            portal, no shipping — your teaching library goes wherever your
            device goes.
          </p>
          <ul className="flex flex-wrap justify-center gap-2.5" data-id="element-123" data-mp="3v0d7z6uaa5qj">
            {devices.map(device => <li key={device.label} className="flex items-center gap-2 rounded-full bg-ivory/10 px-4 py-2 font-sans text-xs text-ivory" data-id="element-124" data-mp="1266bq1e7wg4a">
                <device.icon className="h-3.5 w-3.5 text-gold" strokeWidth={1.8} aria-hidden="true" data-id="element-125" data-mp="x60g6a4tu9gx" />
                {device.label}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}